import { WBCViewActions } from '../actionTypes/wbcView.const';
import axios from 'axios';
import { AuthHeader } from "../helper/auth.token"
import { type } from "os";

var querystring = require('querystring');

export const wbcGridSelected = (value) => ({
    type : WBCViewActions.FILTER_GRID_SELECTED,
    response : value
});

export const wbcChangeImage = (value) => ({
    type : WBCViewActions.FILTER_CHANGE_IMAGE,
    resposne: value,
})

export const updatePageWBCView = (value) => ({
    type: WBCViewActions.UPDATE_PAGE,
    response: value
})

export const updatePageSizeWBC = (value) => ({
    type: WBCViewActions.UPDATE_PAGE_SIZE,
    response: value
})

export const updateAllGridsWBC = (value) => ({
    type: WBCViewActions.UPDATE_ALL_GRIDS,
    response: value,
})

export const updateZStackWBC = (value) => ({
    type: WBCViewActions.UPDATE_Z_STACK,
    response: value
})

export const resetZStackWBC = () => ({
    type: WBCViewActions.RESET_Z_STACK,
})

export const resetWBC = () => ({
    type: WBCViewActions.RESET,
})

export const updateWBCTag = (value) => ({
    type: WBCViewActions.CHANGE_TAG,
    response: value,
})

export const updateWBCSummary = (value) => ({
    type: WBCViewActions.UPDATE_SUMMARY,
    response: value,
})

export const updateZStackWrapperWBC = (selected, zStack) => (dispatch) => {
    console.log("zstackChange", zStack, selected)
    let image_loc = selected.image;
        // "/scan-hdd/morphle_test/2021/12/19/03/18/1_2021-12-19_03-18-48-0000189_Delta39_S1T1R1/tiled/hpf/37_x5y22.jpg"
    let url = image_loc.split('/')
    if(zStack == 0) {
        let idx = url.indexOf('stack');
        if(idx==-1){
            return;
        }
        url[idx]='tiled'
        url.splice(idx+1,1);
    }
    else{
        let idx = url.indexOf('tiled')
        if(idx == -1){
            let idx = url.indexOf('stack');
            url[idx+1]=`S${zStack}`
        } 
        else{
            url[idx]=`stack/S${zStack}`
        }
    }
    url = url.join('/')
    let newSelected = selected;
    newSelected.image = url;
    // dispatch(updateZStackWBC(parseInt(zStack)));
    // dispatch(wbcGridSelected(newSelected));
} 